import React from 'react';

const RFQsOrders = () => (
  <div style={{ padding:'1rem' }}>
    <h1 style={{ marginTop:0 }}>RFQs & Orders</h1>
    <p>End-to-end RFQ, quote, and order tracking workflow will be implemented here.</p>
  </div>
);

export default RFQsOrders;
